import styled from 'styled-components';
import {
  pb, px, mt, pl, py, mb, m, p
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import { styledButton } from '@styles/buttons';
import { StyledLabelPackageForm } from '@styles/labels';
import { StatefulButton } from '@components';
import { PRIMARY_BUTTON } from '@components/StatefulButton/constants';
import { colors } from '@components/ListItemFacility/styles';

export const StyledCover = styled.div`
  ${p(3)};
  ${m(3)};

  ${breakpoint('desktop')`
   max-width: ${props => (props.packageFormScreen ? '' : '460px')};
   max-height: ${props => (props.packageFormScreen ? 'unset' : ' 640px')};
  `};
  background: ${props => (props.packageFormScreen ? 'none' : theme.gradients.LightBlueGradient)}

  border-radius: 10px;
  ${breakpoint('mobile', 'desktop')`
   max-height: ${props => (props.packageFormScreen ? 'unset' : ' 100%')};
   ${({ packageFormScreen }) =>
    packageFormScreen
     && `
    padding:0;
    margin:1rem;
    `};
  `};
`;

export const InfoTimeLineWraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  margin: 0 40px;
  margin-top: 20px;
  & > div:last-child {
    display: none;
  }
`;

export const StyledStepsTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

export const StyledTImeLineText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.navyGray};
`;

export const StyledTimeLineContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledTimeLinePointer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-color: ${({ first }) => (first ? colors.blueNavi : 'none')};
  border: 2px solid ${colors.navyGray};
  ${({ first }) => first && 'border: none'};
`;

export const StyledDashedLine = styled.div`
  display: flex;
  flex: 1;
  margin: 0 20px;
  border: 2px solid ${colors.navyGray};
  height: 1px;
  box-sizing: border-box;
  border-collapse: collapse;
  border-style: dashed;
`;

export const StyledFormDetialsWrapper = styled.div`
  ${({ packageFormScreen }) =>
    packageFormScreen
    && `background-color:${theme.colors.white};
     padding:3rem;
     max-width:640px;
     margin:auto;
     `};
  ${breakpoint('mobile', 'desktop')`
    padding: ${props => (props.packageFormScreen ? '1rem' : '')};
  `};
`;

export const StyledHeadTitle = styled.h2`
  font-weight: bold;
  font-size: 32px;
  text-align: center;
  color: ${colors.navyGray};
  line-height: 1.5rem;
  ${breakpoint('mobile', 'desktop')`
    font-size: 20px;

  `}
  ${({ packageFormScreen }) =>
    packageFormScreen
    && `text-align: center;
     padding-top: 1rem;
     padding-bottom: 1rem;
     color: white;
     `};
`;

export const StyledHeadSubTitle = styled.h3`
  color: ${theme.colors.mediumGray};
  font-weight: bold;
  line-height: normal;
  font-size: 20px;
  ${py(3)};
  ${px(2)};
  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
  `}
`;

export const StyledItemGroup = styled.div`
  display: flex;
  flex: 1;
  ${pb(3)}

  & > div {
    ${pb(0)}
  }
  &:last-child {
    ${pb(0)}
  }
  & > div {
    &:not(:first-child) {
      margin-left: 24px;
    }
  }
  ${breakpoint('mobile', 'tablet')`
  padding-bottom: 24px;
  & > div {
    &:not(:first-child) {
      margin-left: 14px;
    }
  }
    ${({ flexcolumnmobile }) =>
    flexcolumnmobile
      && `
        flex-direction: column;
        & > div:last-child {
          padding-top: 16px;
        }
      & > div {
      &:not(:first-child) {
      margin-left: 0px;
    }
  }
      `};
  `}
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  form {
    width: unset !important;
  }
  ${pb(3)}
  &:last-child {
    ${pb(0)}
  }
  ${({ spacerElement }) => spacerElement && mb(-3)}

  ${breakpoint('desktop')`
    ${({ spacerElement }) => spacerElement && mb(0)}
  `}
`;

export const StyledProfileLabel = styled(StyledLabelPackageForm)`
  font-size: 18px;
  display: flex;
  align-items: center;
  color: ${props => (props.packageFormScreen ? theme.colors.mediumGray : theme.colors.navyGray)};

  text-transform: uppercase;
  justify-content: space-between;
  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
  `};
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  color: ${props => (props.packageFormScreen ? theme.colors.mediumGray : theme.colors.navyGray)};

  height: 45px;
  ${mt(2)}
  ${pl(2.5)}
 .styles__StyledDotOuter-sc-5wnwlz-3 iMNuos {
    background-color: #ffffff;
  }

  .styles__StyledDotInner-sc-5wnwlz-4.jntRSA {
    background-color: #075175;
    width: 100% !important;
    height: 100% !important;
    top: 1px;
    left: 1px;
    align-self: center !important;
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  ${mb(3)}

  h2 {
    ${({ isupper }) => isupper && 'text-transform: uppercase'};
    font-weight: 700;
    font-size: 24px;
    height: 100%;

    ${theme.typography.Raleway}
  }
  ${breakpoint('mobile', 'desktop')`
    h2 {
      font-size: 18px;
    }
    margin-bottom: 16px;
  `}
`;

export const StyledLabelTextWrapper = styled.div`
  color: ${props =>
    (props.packageFormScreen ? theme.colors.newThemeDarkBlue : theme.colors.navyGray)};
  ${breakpoint('desktop')`
  font-size: 16px;
    width:  100% ;
  `}
`;
export const StyledTermsAndConditionsWrapper = styled.label`
  display: flex;
  align-items: center;
  line-height: 1.57;
  font-size: 14px;
  ${mt(1)}
  ${mb(2)}
`;

export const StyledButtonSubmit = styled(StatefulButton).attrs({
  buttonType: PRIMARY_BUTTON
})`
  ${styledButton}
  font-weight: bold;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-height: 40px;
  align-self: center;
  color: ${colors.white};
  background-color: ${colors.blueNavi};
  border: none;
  outline: none;
  padding: 1.5rem;
`;
